// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__zBlm2","pageButton":"Pagination_pageButton__7LlOb","active":"Pagination_active__vveOm"};